<template>
  <PastVisitFields v-model="pastTravels.pastVisit" :has-date="hasVisaDate" />
  <PastRejection v-model="pastTravels.rejection" />
  <SaarcFields v-if="saarc" v-model="pastTravels.SAARC" />
</template>

<script setup lang="ts">
import type { PastTravels } from '~/types';

const pastTravels = defineModel<PastTravels>({ required: true });
defineProps<{
  hasVisaDate?: boolean;
  saarc?: boolean;
}>();
</script>